import React, { useState } from 'react';
import { Users, TrendingUp, Shield, Star, Crown, Zap } from 'lucide-react';
import TeamTab from './enterprise/TeamTab';
import SecurityTab from './enterprise/SecurityTab';
import CommunityHub from '../community/CommunityHub';
import ApiTab from './enterprise/ApiTab';
import './enterprise/enterprise.css';
import AnalyticsTab from './enterprise/AnalyticsTab';

interface CampaignStats {
  totalViews?: number;
  totalSubscribers?: number;
  conversionRate?: string;
  totalCampaigns?: number;
}

interface Campaign {
  id: string;
  _id?: string;
  name?: string;
  viewCount?: number;
  subscriberCount?: number;
  status?: string;
}

interface EnterpriseFeaturesProps {
  userPlan: string;
  userName: string;
  userEmail: string;
  stats: CampaignStats;
  campaigns: Campaign[];
}

export default function EnterpriseFeatures({
  userPlan,
  userName,
  userEmail,
  stats,
  campaigns,
}: EnterpriseFeaturesProps) {
  const [activeTab, setActiveTab] = useState<'team' | 'analytics' | 'security' | 'api' | 'community'>('team');

  const isEnterprise = userPlan === 'enterprise';

  const tabs = [
    { id: 'team' as const, label: 'Team', icon: Users },
    { id: 'analytics' as const, label: 'Analytics', icon: TrendingUp },
    { id: 'security' as const, label: 'Security', icon: Shield },
    { id: 'api' as const, label: 'API', icon: Zap },
    { id: 'community' as const, label: 'Community', icon: Star },
  ];

  return (
    <div className="enterprise-features">
      {/* Header */}
      <div className="enterprise-header">
        <Crown size={16} />
        {isEnterprise ? 'Enterprise' : 'Professional'} Suite
      </div>

      {/* Tabs */}
      <div className="enterprise-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`enterprise-tab ${activeTab === tab.id ? 'enterprise-tab--active' : ''}`}
          >
            <tab.icon size={18} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="enterprise-content">
        {/* TEAM TAB */}
        {activeTab === 'team' && (
          <TeamTab userPlan={userPlan} userEmail={userEmail} />
        )}

        {activeTab === 'analytics' && (
  <AnalyticsTab stats={stats} campaigns={campaigns} />
)} 


        {/* SECURITY TAB */}
        {activeTab === 'security' && <SecurityTab />}

        {/* API TAB (standalone) */}
        {activeTab === 'api' && <ApiTab />}

        {/* COMMUNITY TAB */}
        {activeTab === 'community' && <CommunityHub userPlan={userPlan} />}
      </div>
    </div>
  );
}

// Simple Stat Card Component
function StatCard({ icon, value, label, color, bg }: {
  icon: string;
  value: string;
  label: string;
  color: string;
  bg: string;
}) {
  return (
    <div style={{
      background: bg,
      padding: '18px',
      borderRadius: '12px',
      textAlign: 'center',
      border: `1px solid ${color}20`
    }}>
      <div style={{ fontSize: '28px', marginBottom: '6px' }}>{icon}</div>
      <div style={{ fontSize: '24px', fontWeight: '700', color }}>{value}</div>
      <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>{label}</div>
    </div>
  );
}